import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  showLess: 'Show Less',
})
